import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyLeafCollectionReport } from './Pages/listing';

export const DailyLeafCollectionReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DailyLeafCollectionReport} />
    </Fragment>
)